module.exports = __webpack_public_path__ + "img/tag_blue_oval.e06a1507.svg";